/**
 * Responsável por adicionar o marker de pending order no mapa.
 * @author: adalto.junior
 * Date: 04/12/13
 * Time: 11:51
 */

Greenmile.MarkerPendingOrder = Greenmile.MarkerPendingOrder || {};
Greenmile.MarkerPendingOrder.GeneralFunctions = function () {

    var __map = null;
    this.TEXT_KIND_MARKER = 'pendingOrder';
    this.TEXT_KIND_CLUSTER = 'clusterPendingOrder';

    var getClusterOfPendingOrders = function (context) {

        return function (layers) {

            var __layer;

            for (var layer in layers) {

                if (layers[layer].kind === context.TEXT_KIND_CLUSTER) {
                    __layer = layers[layer];
                }

            }

            return __layer;

        };

    }(this);

    this.setMap = function (map) {

        __map = map;

    };

    this.showMarkerById = function (id) {

        var cluster = getClusterOfPendingOrders(__map._layers);
        var markers = cluster.getLayers();
        var markersLength = markers.length;
        var markerSelected = null;

        for (var i = 0; i < markersLength; i++) {

            var marker = markers[i];

            if (marker.id === id) {
                markerSelected = marker;
                break;
            }
        }

        if (cluster._zoom > 18) {

            __map.fitBounds([markerSelected.getLatLng()]);

        }

        cluster.zoomToShowLayer(markerSelected, function () {

            markerSelected.openPopup();

        });

    };

    this.removeMarkerById = function (id) {

        var layers,
            error;

        if (__map) {

            layers = __map._layers;

            for (var layer in layers) {

                if (layers[layer].kind === this.TEXT_KIND_MARKER && layers[layer].id === id) {
                    __map.removeLayer(layers[layer]);
                }

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                'Map is undefined on error remove marker by id');
            error.console();

        }
    };

    this.removeAllMarkers = function () {

        var layers,
            error;

        if (__map) {

            layers = __map._layers;

            for (var layer in layers) {

                if (layers[layer].kind === this.TEXT_KIND_MARKER ||
                    layers[layer].kind === this.TEXT_KIND_CLUSTER) {
                    __map.removeLayer(layers[layer]);
                }

            }

        } else {

            error = new Monet.Exception.ReturnError(this,
                'Map is undefined on error remove all markers by id');
            error.console();

        }

    };

    this.pendingOrderPopupMap = function (data) {

        var stopDetail = document.createElement("div"),
            stopDetailContent = document.createElement("div"),
            h4 = document.createElement("h4"),
            stopDetailAddress = document.createElement("div");

        stopDetailAddress.className = "stopDetailAddress";

        h4.textContent = data.location.key + (data.location.description ? " - " + data.location.description : "");
        stopDetailAddress.textContent = data.address.join(", ");

        stopDetailContent.appendChild(h4);
        stopDetailContent.appendChild(stopDetailAddress);

        var stopDetailContentFunc = Greenmile.Templates.stopDetailWindow;

        if (data.number) {
            stopDetailContent.appendChild(stopDetailContentFunc({
                span: data.orderNumberLabel,
                windowContent: data.number
            }));
        }

        if (data.createdDate) {
            stopDetailContent.appendChild(stopDetailContentFunc({
                span: data.createdDateLabel,
                windowContent: data.createdDate
            }));
        }

        if (data.priority) {
            stopDetailContent.appendChild(stopDetailContentFunc({
                span: data.priorityLabel,
                windowContent: data.priority
            }));
        }

        if (data.plannedSize1) {
            stopDetailContent.appendChild(stopDetailContentFunc({
                span: data.plannedSize1Label,
                windowContent: data.plannedSize1
            }));
        }

        if (data.plannedPickupSize1) {
            stopDetailContent.appendChild(stopDetailContentFunc({
                span: data.plannedPickupSize1Label,
                windowContent: data.plannedPickupSize1
            }));
        }

        if (data.specialInstructions) {
            var stopOtherInformations = document.createElement("div");
            stopOtherInformations.className = "stopDetailWindow stopOtherInformations";
            stopOtherInformations.textContent = data.specialInstructions;
            stopDetailContent.appendChild(stopOtherInformations);
        }

        stopDetail.appendChild(stopDetailContent);
        return stopDetail.outerHTML;
    };

    this.renderContentToPopup = function (pendingOrder, marker) {

        var divParent = document.createElement('div');
        var divContent = document.createElement('div');
        var divCloseButton = document.createElement('div');
        var btnOpenFilter = document.createElement('input');

        var location = new App.Models.Location(pendingOrder.get('location'));
        var addressFormatted = location.getItemsOfAddress();
        var i18n = Monet.I18n;
        var helper = new Monet.UI.Help('PendingOrderMap', Monet.I18n.getResourcesByKey('Map.Tab.PendingOrders'));
        var contentHelp = helper.render();
        var dateFormatted = Monet.Format.Date.formatToLocale(pendingOrder.get('createdDate'));

        var labelNumberPopup = 'Greenmile.PendingOrders.labelNumberPopup';
        var labelCreatedDatePopup = 'Greenmile.PendingOrders.labelCreatedDatePopup';
        var labelPriorityPopup = 'Greenmile.PendingOrders.labelPriorityPopup';
        var labelPlannedSize1Popup = 'Greenmile.PendingOrders.labelPlannedSize1Popup';
        var labelPlannedPickupSize1Popup = 'Greenmile.PendingOrders.labelPlannedPickupSize1Popup';
        var labelOpenFilterRouteSuggestion = 'Greenmile.PendingOrders.openFilterRouteSuggestion';

        var eventToClosePopup = function (context, marker) {

            return function () {

                marker.closePopup();

                if (!Monet.Session.PendingOrdersNotification.mapLayerIsChecked) {
                    context.removeMarkerById(marker.id);
                }

            };

        }(this, marker);

        var eventToOpenFilterRoute = function (pendingOrder) {

            return function () {

                App.Views.RouteSuggestion.showModalFilter(pendingOrder, '#Maps', '#Maps .container');

                eventToClosePopup();

            };

        }(pendingOrder);

        divContent.className = 'pendingOrderPopupDetail';
        divContent.innerHTML = this.pendingOrderPopupMap({
            location: location.attributes,
            address: addressFormatted,
            orderNumberLabel: i18n.getResourcesByKey(labelNumberPopup),
            number: pendingOrder.get('number'),
            createdDateLabel: i18n.getResourcesByKey(labelCreatedDatePopup),
            createdDate: dateFormatted,
            priorityLabel: i18n.getResourcesByKey(labelPriorityPopup),
            priority: pendingOrder.get('priority'),
            plannedSize1Label: i18n.getResourcesByKey(labelPlannedSize1Popup),
            plannedSize1: pendingOrder.get('plannedSize1'),
            plannedPickupSize1Label: i18n.getResourcesByKey(labelPlannedPickupSize1Popup),
            plannedPickupSize1: pendingOrder.get('plannedPickupSize1'),
            specialInstructions: pendingOrder.get('specialInstructions')
        });

        btnOpenFilter.type = 'button';
        btnOpenFilter.value = i18n.getResourcesByKey(labelOpenFilterRouteSuggestion);

        btnOpenFilter.removeEventListener('click', eventToOpenFilterRoute);
        btnOpenFilter.addEventListener('click', eventToOpenFilterRoute);

        divContent.appendChild(btnOpenFilter);

        divCloseButton.className = 'mapsBtnClosePopup';
        divCloseButton.innerHTML = 'x';
        divCloseButton.removeEventListener('click', eventToClosePopup);
        divCloseButton.addEventListener('click', eventToClosePopup);

        contentHelp.className += ' onToolbar';

        divParent.appendChild(divCloseButton);
        divParent.appendChild(contentHelp);
        divParent.appendChild(divContent);

        return divParent;

    };

    this.createMarker = function (pendingOrder) {

        var location = pendingOrder.get('location');
        var position = [
            location.latitude,
            location.longitude
        ];

        var pendingOrderMarker = new L.marker(position, {
            icon: new L.icon({
                iconUrl: require('static/images/map/markers/generic_marker_blue.png'),
                iconSize: [15, 26],
                iconAnchor: [7.5, 26],
                popupAnchor: [36, -15]
            }),
            zIndexOffset: 0
        });

        pendingOrderMarker.bindPopup(this.renderContentToPopup(pendingOrder, pendingOrderMarker), {
            closeOnClick: false,
            closeButton: false,
            minWidth: 355,
            autoPanPadding: [0, 90]
        });

        pendingOrderMarker.id = pendingOrder.get('id');
        pendingOrderMarker.kind = this.TEXT_KIND_MARKER;

        return pendingOrderMarker;

    };

};

